import { render, staticRenderFns } from "./AssignComponent.vue?vue&type=template&id=86e4cb70&scoped=true&"
import script from "./AssignComponent.vue?vue&type=script&lang=js&"
export * from "./AssignComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e4cb70",
  null
  
)

export default component.exports